import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RelatedpartytransactionsService } from './relatedpartytransactions.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-related-party-transactions',
  templateUrl: './related-party-transactions.component.html',
  styleUrls: ['./related-party-transactions.component.scss']
})
export class RelatedPartyTransactionsComponent implements OnInit{
  constructor(private formbuilder: FormBuilder, private router: Router, private relatedservices: RelatedpartytransactionsService, public commonService: CommonService, public sidenav: SideNavService) { }
  partyform: FormGroup; isJump: any;
  APPeriodId: any;
  NormalRoutng: boolean;
  showBubbledata:any
  ngOnInit(): void {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
      this.createpartytransactions();
    this.getpolicy(this.APPeriodId);
    this.clearfield();
    this.isJump = localStorage.getItem('isJump')
   // this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
     // }
      //else {
      //  this.showBubbledata = null
      //}
   // })

    if (localStorage.getItem("SubmitStatus") == "true")
      this.partyform.disable()
    }
  createpartytransactions() {
    this.partyform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      RelatedPartyTransactionsId: new FormControl(),
      AdditionalInformation1: new FormControl(),
      AdditionalInformation2: new FormControl(),
      AdditionalInformation3: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.partyform.reset()
      }
    })
  }


  Insertrelatedpatrytransactions() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.partyform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.partyform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.partyform.getRawValue();
    this.relatedservices.inserttransactions(formdata).subscribe((data) => {
      this.partyform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Related party transactions", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == "relatedpartytransactions") {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  getpolicy(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.relatedservices.Gettransactions(this.APPeriodId).subscribe((data:any) => {
      if (data) {
        this.partyform.patchValue(data)
        this.commonService.getNotesData();
      }
    })
  }

  getlastyeardata() {
    this.relatedservices.GettransactionsLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  back() {
    this.partyform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Related party transactions", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }



  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.partyform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.Insertrelatedpatrytransactions();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
